import React from 'react'
import { Tabs } from 'antd'
import type { TabsProps } from 'antd'
import { useI18n } from '@/shared/i18n'
import PolicyManagement from './components/PolicyManagement'
import StyleSettings from './components/StyleSettings'
import ForbiddenWords from './components/ForbiddenWords'

const AgentConfigPage: React.FC = () => {
  const { t } = useI18n('modules')

  const items: TabsProps['items'] = [
    {
      key: 'policies',
      label: t('agentConfig.tabs.policies'),
      children: <PolicyManagement />,
    },
    {
      key: 'style',
      label: t('agentConfig.tabs.style'),
      children: <StyleSettings />,
    },
    {
      key: 'forbidden-words',
      label: t('agentConfig.tabs.forbiddenWords'),
      children: <ForbiddenWords />,
    },
  ]

  return (
    <div className="agent-config-page">
      <Tabs items={items} size="large" />
    </div>
  )
}

export default AgentConfigPage
